import { defineComponent as _defineComponent } from 'vue';
import { reactive } from "vue";
import { useRouter } from "vue-router/composables";
import localize from "@/utils/localization";
import DiskUsageSummary from "./DiskUsageSummary.vue";
import BreadcrumbHeading from "@/components/Common/BreadcrumbHeading.vue";
import Heading from "@/components/Common/Heading.vue";
import IconCard from "@/components/IconCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StorageDashboard',
    setup(__props) {
        const router = useRouter();
        const texts = reactive({
            title: localize("Storage Dashboard"),
            subtitle: localize("Here you can see an overview of your disk usage status."),
            freeSpace: {
                title: localize("Is your usage more than expected?"),
                description: localize("Find out what is eating up your space and learn how to easily and safely free up some of it."),
                icon: "fas fa-broom fa-6x",
                buttonText: localize("Free up disk usage"),
            },
            explore_by_history: {
                title: localize("Visually explore your disk usage by history"),
                description: localize("Want to know what histories or datasets take up the most space in your account? Here you can explore your disk usage in a visual way by history."),
                icon: "fas fa-chart-pie fa-6x",
                buttonText: localize("Explore now"),
            },
            explore_by_objectstore: {
                title: localize("Visually explore your disk usage by storage"),
                description: localize("Want to know how the space in your account is being distributed across storages? Here you can explore your disk usage in a visual way by where it is physically stored."),
                icon: "fas fa-hdd fa-6x",
                buttonText: localize("Explore now"),
            },
        });
        const breadcrumbItems = [{ title: texts.title }];
        function goToStorageManager() {
            router.push({ name: "StorageManager" });
        }
        function goToHistoriesOverview() {
            router.push({ name: "HistoriesOverview" });
        }
        function goToObjectStoresOverview() {
            router.push({ name: "ObjectStoresOverview" });
        }
        return { __sfc: true, router, texts, breadcrumbItems, goToStorageManager, goToHistoriesOverview, goToObjectStoresOverview, DiskUsageSummary, BreadcrumbHeading, Heading, IconCard };
    }
});
